import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import Job, { datefor } from './Job.js';

export const STALE_INWARD_THRESHOLD_MS = 3 * 24 * 60 * 60 * 1000;

export function getLatestInwardedTime(jobs) {
	var latest = jobs[0].lastInwardedTime;
	for (var i = 1; i < jobs.length; i++) {
		if (new Date(jobs[i].lastInwardedTime).getTime() > new Date(latest).getTime()) {
			latest = jobs[i].lastInwardedTime;
		}
	}
	return latest;
}

export function isGroupStale(jobs) {
	return (Date.now() - new Date(getLatestInwardedTime(jobs)).getTime()) > STALE_INWARD_THRESHOLD_MS;
}

export default class ProductGroupTile extends Component {
	handleSelectAllChange = () => {
		var jobs = this.props.group.jobs;
		var allChecked = jobs.every(function (job) { return job.checked; });
		var newCheckedState = !allChecked;
		var jobActionPerformed = this.props.jobActionPerformed;
		jobs.forEach(function (job) {
			if (job.checked !== newCheckedState) {
				job.checked = newCheckedState;
				jobActionPerformed(job);
			}
		});
		this.forceUpdate();
	}

	render() {
		var group = this.props.group;
		var latestInwardedTime = getLatestInwardedTime(group.jobs);
		var isStale = isGroupStale(group.jobs);
		var allChecked = group.jobs.every(function (job) { return job.checked; });
		return (
			<div className={'putaway-pallet-outer putaway-pallet-outer-no-margin-top' + (isStale ? ' putaway-pallet-outer-stale' : '')}>
				<div className="row">
					<div className="col-xs-2 col-md-1" style={{ marginTop: '40px', marginLeft: '15px' }}>
						<Checkbox
							checked={allChecked}
							onChange={this.handleSelectAllChange}
							value="checkedG"
							classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }}
						/>
					</div>
					<div className="col-xs-2 col-md-1 no-left-padding">
						<img
							src={group.imageUrl}
							style={{ maxWidth: '100%', maxHeight: '100px', marginLeft: '20px' }}
							alt="product"
						/>
					</div>
					<div className="col-xs-8 col-md-10">
						<div className="row">
							<div className="col-xs-8 col-md-9" style={{ fontSize: '16px', color: '#212121', lineHeight: '22px', marginTop: '15px' }}>
								{group.title}
							</div>
							<div className="col-xs-4 col-md-3 no-padding">
								<div className="putaway-product-label" style={{ marginTop: '15px' }}>
									Last Inwarded Time
								</div>
								<div className="putaway-product-value" style={{ marginTop: '8px', color: isStale ? '#de463a' : undefined, fontWeight: isStale ? 'bold' : 'normal' }}>
									{datefor.format(latestInwardedTime)}
								</div>
							</div>
						</div>
						<div className="putaway-product-label" style={{ marginTop: '5px' }}>
							{group.jobs.length} {group.jobs.length > 1 ? 'locations' : 'location'}
						</div>
					</div>
				</div>
				<div style={{ marginTop: '10px' }}>
					{group.jobs.map((job, index) => {
						return (
							<div
								key={index}
								className={isStale ? 'putaway-product putaway-product-stale' : 'putaway-product'}
								style={{ marginTop: index === 0 ? 0 : '15px' }}
							>
								<Job job={job} jobActionPerformed={this.props.jobActionPerformed} hideProductHeader={true} />
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/ProductGroupTile.js